import React, { useState, useEffect } from 'react';
import Layout from '../component/layout';
import { useNavigate } from 'react-router-dom';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Link } from 'react-router-dom';
import { toastify } from '../../../utils/toast';
import { getItem } from '../../../utils/localStorage'
import { makeRequest2 } from '../../../utils/makeRequest';
import { getCampaignsURL } from '../../../utils/urls';
import { filterObjectsByAllProperties } from '../../../utils/filterSearch';

const Campaigns = () => {
  const navigate = useNavigate();
  const [campaigns, setCampaigns] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [allCampaigns, setAllCampaigns] = useState([]);

  const getCampaigns = async () => {
    try {
      const facilityId = await getItem('selectedFacilityId');
      const response = await makeRequest2(`${getCampaignsURL}/${facilityId}`, 'GET', {});
      console.log("Response", response);
      if (response.success) {
        setAllCampaigns(response.data); // Store original data
        setCampaigns(response.data);    // Display all initially
      } else {
        throw new Error(response.error);
      }
    } catch (err) {
      toastify(err.message, 'error');
    }
  }

  const allCampaignsCount = allCampaigns.length;
  const activeCampaignsCount = allCampaigns.filter(campaign => campaign.status === "Ongoing").length;
  const completedCampaignsCount = allCampaigns.filter(campaign => campaign.status === "Completed").length;

  const actionTemplate = (rowData) => {
    return (
      <div>
        <Link
          to={`/facility/campaigns/view_campaign/${rowData._id}`}
          style={{
            color: '#007bff',
            textDecoration: 'none',
            fontSize: '18px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            border: '2px solid #007bff',
            width: '40px',
            height: '40px',
          }}
          title="View Campaign"
        >
          <i className="ti ti-eye"></i>
        </Link>
      </div>
    );
  };

  const statusTemplate = (rowData) => {
    const statusStyles = {
      Draft: { color: '#28a745', backgroundColor: '#e9fbe9' },
      Completed: { color: '#17a2b8', backgroundColor: '#e0f4f7' },
      Failed: { color: '#dc3545', backgroundColor: '#fde9e9' },
      Scheduled: { color: '#ffc107', backgroundColor: '#fff8e1' },
    };

    const style = statusStyles[rowData.status] || {
      color: '#6c757d',
      backgroundColor: '#f1f1f1',
    };

    return (
      <span
        style={{
          ...style,
          padding: '0.5em 1em',
          borderRadius: '12px',
          fontWeight: 'bold',
          fontSize: '0.9rem',
          display: 'inline-block',
        }}
      >
        {rowData.status}
      </span>
    );
  };

  const handleInputSearch = async (value) => {
    try {
      setSearchTerm(value);
      if (value === '') {
        setCampaigns(allCampaigns); // Restore original data
      } else {
        const results = await filterObjectsByAllProperties(allCampaigns, value); // Filter from original data
        setCampaigns(results); // Update displayed data
      }
    } catch (error) {
      toastify(error.message, 'error');
    }
  };

  useEffect(() => {
    getCampaigns();
  }, []);

  return (
    <Layout>
      <div className="row">
        <div className="col-sm-12">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h5>Add Campaign</h5>
                </div>
                <div className='card-body'>
                  <div className="row">
                    <div className="col-lg-12 col-xxl-12">
                      <div className="card">
                        <div className="card-body position-relative">
                          <div className="container mt-4">
                            {/* Header */}
                            <div className="d-flex justify-content-between align-items-center mb-4">
                              <h1 className="h4">Campaign Dashboard</h1>
                              <button className="btn btn-primary d-flex align-items-center"
                                onClick={() => navigate('/facility/campaigns/add_campaign')}
                              >
                                <i className="bi bi-plus me-2"></i> New Campaign
                              </button>
                            </div>
                            {/* Overview Cards */}
                            <div className="row">
                              <div className="col-md-4">
                                <div className="card p-3 text-center">
                                  <h5 className='text-primary'>Total Campaigns</h5>
                                  <h2 className="fw-bold">{allCampaignsCount}</h2>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="card p-3 text-center">
                                  <h5 className='text-info'>Active Campaigns</h5>
                                  <h2 className="fw-bold">{activeCampaignsCount}</h2>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="card p-3 text-center">
                                  <h5 className='text-success'>Completed Campaigns</h5>
                                  <h2 className="fw-bold">{completedCampaignsCount}</h2>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-3 col-sm-6 mb-2">
                            <input
                              className="form-control"
                              placeholder="Search campaigns"
                              value={searchTerm}
                              onChange={(e) => handleInputSearch(e.target.value)}
                            />
                          </div>

                          <div className="table-responsive">
                            <DataTable value={campaigns}
                              emptyMessage="No Campaigns found."
                              sortMode="multiple"
                              paginator rows={10}
                              stripedRows
                              tableStyle={{ minWidth: '50rem' }}
                              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} campaigns"
                              rowsPerPageOptions={[10, 15, 25, 50, 75, 100]}
                            >
                              <Column field="name" header="Name"></Column>
                              <Column field="campaignType" header="Type" body={(rowData) =>
                                rowData.campaignType
                                  ? rowData.campaignType.charAt(0).toUpperCase() + rowData.campaignType.slice(1)
                                  : ''
                              }></Column>
                              <Column field="objective" header="Objective"></Column>
                              <Column field="targetAudience" header="Audience" body={(rowData) =>
                                rowData.targetAudience
                                  ? rowData.targetAudience.charAt(0).toUpperCase() + rowData.targetAudience.slice(1)
                                  : ''
                              }></Column>
                              <Column field="channels" header="Channels" body={(rowData) => rowData.channels.join(", ")} ></Column>
                              <Column field="status" header="Status" body={statusTemplate}></Column>
                              <Column header="Actions"
                                body={actionTemplate}
                              ></Column>
                            </DataTable>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout >
  );
};

export default Campaigns;
